<template>
    <!-- Modal -->
    <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="documento || idGuias || batch_mode">
                <div class="modal-header">
                    <h5 class="modal-title">IpSign - Selecione o meio de assinatura</h5>
                    <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="progress mt-1 mb-2" v-if="$store.state.loading || batch_processing">
                        <div class="indeterminate" v-if="$store.state.loading || batch_processing"></div>
                    </div>

                    <template>
                       <az-input
                            placeholder="Selecione o meio de assinatura"
                            label="Selecione o meio de assinatura"
                            type="select"
                            :optionsList="[
                                {
                                    'id': 'dispositivo',
                                    'nome': 'Dispositivo',
                                },
                                {
                                    'id': 'email',
                                    'nome': 'E-mail / Link',
                                },
                            ]"
                            optionsDisplay="nome"
                            optionsData="id"
                            :edicao="!link"
                            v-model="meio" />

                        <az-input
                            class="mt-1"
                            label="Obter link para envio"
                            type="checkbox-group"
                            v-if="meio == 'email' && !idGuias"
                            :edicao="!link"
                            v-model="obter_link" />

                       <az-input
                            placeholder="Selecione o dispositivo"
                            label="Selecione o dispositivo"
                            type="select"
                            :optionsList="dispositivos"
                            optionsDisplay="nome"
                            optionsData="id"
                            v-model="dispositivo"
                            :edicao="meio == 'dispositivo'"
                            v-if="meio && meio == 'dispositivo'" />

                        <template v-else>

                            <az-input
                                placeholder="E-mail"
                                label="Informe o e-mail"
                                type="email"
                                v-model="email"
                                :validate="validate" />

                        </template>

                       <az-input
                            placeholder="cpf"
                            label="Informe o cpf"
                            type="cpf"
                            :edicao="!link"
                            v-model="cpf" />

                       <az-input
                            placeholder="Nome"
                            label="Nome"
                            :edicao="!link"
                            v-model="nome" />

                        <template v-if="link">
                            <div class="alert alert-info mt-3 mb-0 d-flex justify-content-between">
                                <div>Link para Assinatura</div>
                                <div>
                                    <a href="#" @click.prevent="copiar_clipboard()" title="Copiar link.">
                                        <i class="fa-solid fa-copy"></i>
                                    </a>
                                </div>
                            </div>
                        </template>

                        <template v-if="batch_mode">
                            <div class="mt-3">
                                <div class="alert alert-secondary py-2 mb-2">
                                    <strong>Assinatura em lote</strong>
                                    <div class="small mb-0">Selecione os documentos que devem ser assinados.</div>
                                </div>

                                <div class="mb-2">
                                    <a href="#" @click.prevent="marcar_todos_batch(true)" class="card-link mr-2" v-if="!batch_processing">Marcar todos</a>
                                    <a href="#" @click.prevent="marcar_todos_batch(false)" class="card-link" v-if="!batch_processing">Desmarcar todos</a>
                                </div>

                                <div class="list-group" style="max-height: 220px; overflow-y: auto;">
                                    <label class="list-group-item py-2" v-for="(item, idx) in batch_docs" :key="'ipsign-batch-' + idx">
                                        <input
                                            type="checkbox"
                                            class="mr-2"
                                            :value="item._batch_key"
                                            v-model="batch_selected_ids"
                                            :disabled="batch_processing" />
                                        {{ item.st_nome }}
                                    </label>
                                </div>

                                <div class="mt-2 small" v-if="batch_processing">
                                    Processando {{ batch_done }} / {{ batch_total }}
                                </div>

                                <div class="mt-2" v-if="batch_links.length">
                                    <div class="font-weight-bold mb-1">Links gerados</div>
                                    <div style="max-height: 200px; overflow-y: auto;">
                                        <div class="alert alert-info py-2 mb-2 d-flex justify-content-between" v-for="(item, idx) in batch_links" :key="'ipsign-link-' + idx">
                                            <div>
                                                <div class="font-weight-bold">{{ item.nome }}</div>
                                                <div class="small text-break">{{ item.link }}</div>
                                            </div>
                                            <div class="ml-2 text-nowrap">
                                                <a href="#" @click.prevent="copiar_link_lote(item.link)" title="Copiar link" class="card-link">
                                                    <i class="fa-solid fa-copy"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">
                        Fechar
                    </button>
                    <az-submit @click="assinar()" :disabled="link || batch_processing">{{ batch_mode ? 'Assinar selecionados' : 'Assinar' }}</az-submit>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
// import _ from "lodash";
import AzInput from "../shared/forms/AzInput.vue";
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() {
        return {
            documento: null,
            dispositivos: null,
            dispositivo: null,
            meio: 'dispositivo',
            email: null,
            cpf: null,
            nome: null,
            dt_nascimento: null, 
            nomeArquivo: null,
            unidade: "",
            operadora: "",
            chave_assinatura: "",
            qtd_ocor_ass: 0,
            obter_link: false, 
            link: null, 
            validate: false, 
            idGuias: null,
            uuidModal: null,
            other_model_id : null,
            other_model_type : null,
            other_id_atendimento : null,
            batch_mode: false,
            batch_docs: [],
            batch_selected_ids: [],
            batch_ctx: null,
            batch_processing: false,
            batch_done: 0,
            batch_total: 0,
            batch_links: [],
            batch_errors: [],
        };
    },

    props: ['model_id', 'model_type', 'id_modelo_documento'],

    components: {
        AzInput,
        AzSubmit
    },

    computed: {
        modal_id: function () {
            return 'ipsignModal' + this.uuidModal;
        },
    },

    methods: {
        fechar_modal() { 
            $("#" + this.modal_id).modal("hide");
        },

        copiar_clipboard () { 
            this.$util.copiar_clipboard(
                this, 
                this.link,
                'Link copiado.'
            );
        },

        copiar_link_lote (link) {
            this.$util.copiar_clipboard(this, link, 'Link copiado.');
        },

        reset_batch() {
            this.batch_mode = false;
            this.batch_docs = [];
            this.batch_selected_ids = [];
            this.batch_ctx = null;
            this.batch_processing = false;
            this.batch_done = 0;
            this.batch_total = 0;
            this.batch_links = [];
            this.batch_errors = [];
        },

        marcar_todos_batch(marcar = true) {
            if (marcar) {
                this.batch_selected_ids = this.batch_docs.map(item => item._batch_key);
                return;
            }

            this.batch_selected_ids = [];
        },

        load() {
            this.dispositivos = [];

            this.$util.load(this, {
                service: "ipsign",
                func: "dispositiivos",
                redir_api: true, 
                parms: {
                    model_type: this.model_type,
                    model_id: this.model_id,
                },
                toast: false,
                loadTo: res => {
                    if(res && res.length) {
                        this.dispositivos = res;
                    }
                }
            });

            this.dispositivo = this.$util.getCookie('dispositivo-ipsign');
        },

        show(documentoBase64, nomeArquivo, email, cpf, nome, unidade = "", operadora = "", chave_assinatura = "", qtd_ocor_ass = 0, dt_nascimento = "", model_id = null, model_type = null, id_atendimento = null) {
            this.validate = false;
            this.reset_batch();

            this.load();

            if(nomeArquivo && nomeArquivo != '') {
                this.nomeArquivo = nomeArquivo.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            } else {
                this.nomeArquivo = 'documento_ipsign';
            }

            this.documento = documentoBase64;
            this.email = email;
            this.cpf = cpf;
            this.nome = nome;
            this.dt_nascimento = dt_nascimento;
            this.unidade = unidade;
            this.operadora = operadora;
            this.chave_assinatura = chave_assinatura;
            this.qtd_ocor_ass = qtd_ocor_ass;
            this.link = "";

            if (model_id && model_type) {
                this.other_model_id = model_id;
                this.other_model_type = model_type;
                this.other_id_atendimento = id_atendimento;
            }
            
            $("#" + this.modal_id).modal("show");
        },

        show_batch(payload = {}) {
            this.validate = false;
            this.load();
            this.reset_batch();

            this.documento = '';
            this.nomeArquivo = 'documento_ipsign_lote';
            this.idGuias = null;
            this.email = payload.email;
            this.cpf = payload.cpf;
            this.nome = payload.nome;
            this.dt_nascimento = payload.dt_nascimento;
            this.unidade = payload.unidade || '';
            this.operadora = payload.operadora || '';
            this.chave_assinatura = 'ASS:';
            this.qtd_ocor_ass = 0;
            this.link = '';

            this.batch_mode = true;
            this.batch_docs = (payload.docs || [])
                .filter(item => item && item.id_modelo_documento)
                .map((item, idx) => ({ ...item, _batch_key: idx + '-' + item.id_modelo_documento }));
            this.batch_selected_ids = this.batch_docs.map(item => item._batch_key);
            this.batch_ctx = {
                id_marcacao: payload.id_marcacao,
                pa_id: payload.pa_id,
            };

            $("#" + this.modal_id).modal("show");
        },
        
        show_guias(idGuias, email, cpf, nome, unidade = "", operadora = "", chave_assinatura = "", qtd_ocor_ass = 0, dt_nascimento = "") {
            this.validate = false;
            this.reset_batch();

            this.load();
            
            this.documento = '';
            this.nomeArquivo = 'guia_ipsign';
            this.idGuias = idGuias

            this.email = email;
            this.cpf = cpf;
            this.nome = nome;
            this.dt_nascimento = dt_nascimento;
            this.unidade = unidade;
            this.operadora = operadora;
            this.chave_assinatura = chave_assinatura;
            this.qtd_ocor_ass = qtd_ocor_ass;
            this.link = "";

            $("#" + this.modal_id).modal("show");
        },

        async assinar() {
            if (this.batch_mode) {
                await this.assinar_lote();
                return;
            }

            this.$util.setCookie('dispositivo-ipsign', this.dispositivo);

            this.$util.atualizar(this, {
                service: "ipsign",
                func: "assinar",
                redir_api: true, 
                dados: {
                    model_id: this.other_model_id ? this.other_model_id : this.model_id,
                    model_type: this.other_model_type ? this.other_model_type : this.model_type,
                    pdf: this.documento,
                    nome_arquivo: this.nomeArquivo,
                    meio: this.meio,
                    id_dispositivo: this.dispositivo,
                    email: this.email,
                    cpf: this.cpf,
                    nome: this.nome,
                    dt_nascimento: this.dt_nascimento, 
                    unidade: this.unidade,
                    operadora: this.operadora,
                    chave_assinatura: this.chave_assinatura,
                    qtd_ocor_ass: this.qtd_ocor_ass,
                    id_modelo_documento: this.id_modelo_documento,
                    obter_link: this.obter_link, 
                    id_guias: this.idGuias,
                    id_atendimento : this.other_id_atendimento
                },
                toast: false,
                callback: res => {
                    if(res && res.status_code == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Atualizar",
                            detail: res.msg ? res.msg : "Documento enviado com sucesso",
                            life: 3000
                        });

                        if ( this.meio == 'email' && this.obter_link ) { 
                            this.link = res.link;
                            return;
                        }
                    }

                    $("#" + this.modal_id).modal("hide");
                }
            });
        },

        gerar_pdf_lote(doc) {
            return this.axios.post('/imprimir/documento_recepcao', {
                ...doc,
                id_marcacao: this.batch_ctx ? this.batch_ctx.id_marcacao : null,
                pa_id: this.batch_ctx ? this.batch_ctx.pa_id : null,
                refresh: true,
                assinar: true,
            });
        },

        assinar_item_lote(doc, pdf) {
            return new Promise((resolve, reject) => {
                this.$util.atualizar(this, {
                    service: 'ipsign',
                    func: 'assinar',
                    redir_api: true,
                    dados: {
                        model_id: this.other_model_id ? this.other_model_id : this.model_id,
                        model_type: this.other_model_type ? this.other_model_type : this.model_type,
                        pdf: pdf,
                        nome_arquivo: (doc.st_nome && doc.st_nome != '' ? doc.st_nome : 'documento_ipsign').replace(/[^a-z0-9]/gi, '_').toLowerCase(),
                        meio: this.meio,
                        id_dispositivo: this.dispositivo,
                        email: this.email,
                        cpf: this.cpf,
                        nome: this.nome,
                        dt_nascimento: this.dt_nascimento,
                        unidade: this.unidade,
                        operadora: this.operadora,
                        chave_assinatura: this.chave_assinatura,
                        qtd_ocor_ass: this.qtd_ocor_ass,
                        id_modelo_documento: doc.id_modelo_documento,
                        obter_link: this.obter_link,
                        id_atendimento: this.other_id_atendimento,
                    },
                    toast: false,
                    callback: res => {
                        if (res && res.status_code == 200) {
                            resolve(res);
                            return;
                        }

                        reject(res);
                    }
                });
            });
        },

        async assinar_lote() {
            if (!this.batch_selected_ids.length) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Selecione ao menos um documento.',
                    life: 5000
                });
                return;
            }

            this.$util.setCookie('dispositivo-ipsign', this.dispositivo);

            this.batch_processing = true;
            this.batch_links = [];
            this.batch_errors = [];

            const selecionados = this.batch_docs.filter(item => this.batch_selected_ids.indexOf(item._batch_key) >= 0);
            this.batch_total = selecionados.length;
            this.batch_done = 0;

            for (const doc of selecionados) {
                try {
                    const resPdf = await this.gerar_pdf_lote(doc);
                    const payload = resPdf && resPdf.data ? resPdf.data : null;

                    if (!payload || !payload.pdf) {
                        throw new Error('PDF não retornado.');
                    }

                    const resAss = await this.assinar_item_lote(doc, payload.pdf);

                    if (this.meio == 'email' && this.obter_link && resAss && resAss.link) {
                        this.batch_links.push({
                            nome: doc.st_nome,
                            link: resAss.link,
                        });
                    }
                } catch (error) {
                    this.batch_errors.push({
                        nome: doc.st_nome,
                        erro: error && error.msg ? error.msg : (error && error.message ? error.message : 'Erro ao assinar documento.'),
                    });
                }

                this.batch_done++;
            }

            this.batch_processing = false;

            if (this.batch_errors.length) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Assinatura em lote',
                    detail: 'Concluído com pendências. Sucesso: ' + (this.batch_total - this.batch_errors.length) + ' / ' + this.batch_total,
                    life: 7000
                });
                return;
            }

            this.$toast.add({
                severity: 'success',
                summary: 'Assinatura em lote',
                detail: 'Todos os documentos foram processados com sucesso.',
                life: 5000
            });

            if (!(this.meio == 'email' && this.obter_link)) {
                $("#" + this.modal_id).modal("hide");
            }
        }
    },
    
    mounted() {
        const uuid = this.$util.uuidv4();
        this.uuidModal = uuid;
    },

};
</script>
